import {
  GET_MANAGER_COMPLAINTS,
  GET_MANAGER_COMPLAINT_DETAIL,
  RESOLVE_MANAGER_COMPLAINT,
  REJECT_MANAGER_COMPLAINT,
  CLEAR_MANAGER_COMPLAINT_DETAIL,
} from './actionTypes';

export const actionGetManagerComplaints = (payload) => ({
  payload,
  type: GET_MANAGER_COMPLAINTS,
});

export const actionGetManagerComplaintDetail = (payload) => ({
  payload,
  type: GET_MANAGER_COMPLAINT_DETAIL,
});

export const actionResolveManagerComplaint = (payload) => ({
  payload,
  type: RESOLVE_MANAGER_COMPLAINT,
});

export const actionRejectManagerComplaint = (payload) => ({
  payload,
  type: REJECT_MANAGER_COMPLAINT,
});

export const actionClearManagerComplaintDetail = () => ({
  type: CLEAR_MANAGER_COMPLAINT_DETAIL,
});

export default actionGetManagerComplaints;
